import request from '@/utils/request'
let baseURL = '/anttalk-org';


// 通过短链接码换取参数
export function shortUrlCode(params) {
  return request({
    url: '/api/org/shorturl/v1/params',
    method: 'get',
    baseURL,
    params
  })
}

// 组织邀请新用户注册成功后上报 (此接口用于后台发送APP 邀请加入组织的通知)
export function memberInviteTargetOpenId(data) {
  return request({
    url: '/api/org/member/v1/memberInvite/targetOpenId',
    method: 'put',
    baseURL,
    data
  })
}